// Faint topographic contour lines behind Home (06-UX.md → Home). Static in M0.
const RINGS = [0, 1, 2, 3, 4, 5, 6, 7];

function hill(i: number): string {
  const s = 1 + i * 0.22;
  const cx = 280;
  const cy = 250;
  // A lumpy closed ring, scaled outward per contour interval.
  const p = (x: number, y: number): string => `${cx + x * s} ${cy + y * s}`;
  return (
    `M ${p(0, -60)} C ${p(50, -70)} ${p(95, -25)} ${p(80, 15)} ` +
    `S ${p(40, 75)} ${p(-10, 60)} S ${p(-90, 40)} ${p(-75, -5)} S ${p(-45, -55)} ${p(0, -60)} Z`
  );
}

function ridge(i: number): string {
  const y = 560 + i * 24;
  return `M -40 ${y} C 80 ${y - 50 + i * 3}, 170 ${y + 70 - i * 4}, 260 ${y + 10} S 400 ${y - 40}, 460 ${y}`;
}

export function Contours() {
  return (
    <svg
      class="contours"
      viewBox="0 0 400 800"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke">
        {RINGS.map((i) => (
          <path key={`h${i}`} d={hill(i)} vector-effect="non-scaling-stroke" />
        ))}
        {RINGS.map((i) => (
          <path key={`r${i}`} d={ridge(i)} vector-effect="non-scaling-stroke" />
        ))}
      </g>
    </svg>
  );
}
